import { getItem, setItem } from 'services/localStorage/cache'
import { DocumentState } from 'types/enums'

import { fetchData as fetchApplicationDocumentsData } from '../services/api/core/applications/documents'
import { fetchData as fetchPeopleDocumentsData } from '../services/api/core/people/documents'

const mapDocumentState = (state: string): DocumentState => {
  switch (state) {
    case 'validated':
      return DocumentState.Validated
    case 'complete':
      return DocumentState.Attached
    case 'validating':
      return DocumentState.Attached
    case 'incomplete':
    default:
      return DocumentState.Pending
  }
}

async function fetchData(
  applicationId: string,
  peopleId: string,
): Promise<{
  identityProof: DocumentState
  residenceProof: DocumentState
  incomeProof: DocumentState
  inspectionAppraisal: DocumentState
}> {
  const cacheKey = `fetchDocuments:${applicationId}`
  const cacheValue = getItem(cacheKey)

  if (cacheValue) {
    return cacheValue
  }

  try {
    const { inspectionAppraisal } =
      await fetchApplicationDocumentsData(applicationId)
    const { identityProof, residenceProof, incomeProof } =
      await fetchPeopleDocumentsData(peopleId)

    const data = {
      identityProof: mapDocumentState(identityProof.status),
      residenceProof: mapDocumentState(residenceProof.status),
      incomeProof: mapDocumentState(incomeProof.status),
      inspectionAppraisal: mapDocumentState(inspectionAppraisal.status),
    }

    setItem(cacheKey, data)
    return data
  } catch (error) {
    return {
      identityProof: DocumentState.Pending,
      residenceProof: DocumentState.Pending,
      incomeProof: DocumentState.Pending,
      inspectionAppraisal: DocumentState.Pending,
    }
  }
}

export { fetchData }
